import React from 'react'
import './Dark.css';

const Navbar = () => {
    return (
        <div className="navbar">
            <h3>React.js To Do List</h3>
            <h6>by <a
                href="https://milostrifunovic1.github.io/portfolio/"
                target="_blank"
                rel="noopener noreferrer">
                Miloš Trifunović</a></h6>
        </div>
    )
}

export default Navbar;
